import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { SuccessScreen } from 'shared/components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as loginActions from 'core/duck';
import './EmailVerification.scss';

class EmailVerification extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: {
        verificationCode: props.hash,
        username: props.username,
      },
    };

    this.props.actions.verifyUser(this.state.user);
  }

  render() {
    const { verifiedUser, error } = this.props;
    if (verifiedUser === null) {
      return null;
    }
    return verifiedUser ? (
      <SuccessScreen
        data={{
          copy: 'register.accountVerifiedMessage',
          buttonLabel: 'common.labels.continueToSignIn',
          link: '/login',
          reloadLinkPage: true,
        }}
      />
    ) : (
      <section className="email-verification text-center">
        <span className="text-error">{error && error.message}</span>
        <a href="/login" rel="noreferrer noopener" className="btn btn-outline mt-3">
          {this.props.t('common.labels.continueToSignIn')}
        </a>
      </section>
    );
  }
}

EmailVerification.propTypes = {
  username: PropTypes.string.isRequired,
  actions: PropTypes.shape({
    verifyUser: PropTypes.func.isRequired,
  }).isRequired,
  verifiedUser: PropTypes.bool,
  error: PropTypes.shape({
    message: PropTypes.string,
  }),
  hash: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

EmailVerification.defaultProps = {
  error: undefined,
  verifiedUser: null,
};

function mapStateToProps(state) {
  const { users } = state;
  return {
    currentUser: users.currentUser,
    verifiedUser: users.verifiedUser,
    error: users.error,
  };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators(loginActions, dispatch) };
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(EmailVerification));
